import { useContext, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { SelectField } from "../../../components/fields/SelectField";
import { AccountContext } from "../../../context/AccountContextComponent";
import { formatOwnerOptions } from "../formatters";

export const ObjectiveOwnerFilterSelect = ({ onSelection, ownersSelected }) => {
  const { accountData } = useContext(AccountContext);

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      ownerId: "",
    },
  });

  const ownerOptions = useMemo(
    () => formatOwnerOptions(accountData, ownersSelected, true, true),
    [accountData, ownersSelected]
  );

  const clearOwnerId = () => {
    form.setValue("ownerId", "");
  };

  return (
    <FormProvider {...form}>
      <form
        key={ownersSelected?.length}
        // Prevent form submission on enter key
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <SelectField
          field={{
            id: "ownerId",
            placeholder: "+ Owner Filter",
          }}
          options={ownerOptions}
          onSelectionChange={(e) => {
            clearOwnerId();
            onSelection(e);
          }}
          selectProps={{
            variant: "unstyled",
            components: {
              DropdownIndicator: () => null,
            },
          }}
          selectStyles={{
            control: (provided) => ({
              ...provided,
              cursor: "pointer",
              padding: "0px 4px 0px 4px",
              borderRadius: "10px",
              // border: "1px solid",
              _hover: {
                bg: "gray.100",
              },
              fontSize: "sm",
            }),
          }}
        />
      </form>
    </FormProvider>
  );
};
